import React, { useEffect } from "react";

const useWindowTop = ()=>{

    useEffect(()=>{
        window.scrollTo({top:'0'})
 
    },[])

}

export default useWindowTop